export const effects = {
  boxShadow: {
    card: '0px 1px 3px 0px rgba(51, 69, 96, 0.20)',
    'rule-01': '0px 0px 6px rgba(0, 0, 0, 0.10)',
    'rule-02': '0px 0px 5px rgba(224, 10, 23, 0.15)',
  },
  opacity: {
    disabled: '40%',
    lg: '80%',
    md: '50%',
    sm: '20%',
  },
} as const
